import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import useGetSync from '../../../services/um/line/useGetSync'
import useTranslate from '../../../i18n/useTranslate'

function Line() {
    const t = useTranslate()
    const classes = useStyles()
    const { isSync } = useGetSync()

    const checkSync = (whenTrue: any, whenFalse: any) => {
        return isSync ? whenTrue : whenFalse
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <Typography variant="h6">{t.get('UM.PROFILE.CONNECT_LINE')}</Typography>
                <Typography variant="caption">{t.get('UM.PROFILE.CONNECT_LINE_DESCRIPTION')}</Typography>
            </Grid>
            <Grid item xs={12} md={8} direction="column">
                <img src={process.env.REACT_APP_LINE_QR} alt="line-qr" className={classes.img} />
                <div className={classes.status}>
                    {checkSync(
                        <CheckCircleIcon className={classes.checkIcon} />,
                        <AutorenewIcon className={classes.progressIcon} />,
                    )}
                    {checkSync(
                        <Typography>{t.get('UM.PROFILE.SYNC_LINE_SYNCED')}</Typography>,
                        <Typography>{t.get('UM.PROFILE.SYNC_LINE_INPROGRESS')}</Typography>,
                    )}
                </div>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    img: {
        width: 240,
        height: 240,
    },
    checkIcon: {
        fill: 'green',
        margin: theme.spacing(0, 1),
    },
    progressIcon: {
        fill: '#0a66b7',
        margin: theme.spacing(0, 1),
    },
    status: {
        display: 'flex',
        alignItems: 'center',
    },
}))

export default Line
